export default __webpack_public_path__ + "static/media/receiver.9f7f4452.png";